import React, { useState, useEffect } from 'react';

function APIS({ setGlobalData }) {
    const [error, setError] = useState(null);

    const [apiData, setApiData] = useState({
        sliders: { main: [], favourite: [], feature: [], affiliate: [], commssion: [], promotion: [], product: [], guide: [], contact: [], about: [] },
        socialLinks: [],
        general: {},
        promotions: { activePromotion: [], displayPromotion: [], allPromotions: [] },
    });

    useEffect(() => {
        const fetchPublicData = async () => {
            try {
                const token = localStorage.getItem('token');
                let currentOrigin = window.location.origin;
                if (currentOrigin.includes("aff.")) {
                    currentOrigin = currentOrigin.replace("aff.", "www.");
                }
                currentOrigin = currentOrigin.replace(/\/$/, "");

                const headers = {
                    ...(token ? { Authorization: `Bearer ${token}` } : {}),
                    Origin: currentOrigin,
                };

                const [slidersData, socialData, generalData, promotionsData] = await Promise.all([
                    fetch(`${process.env.REACT_APP_API_URL}/api/sliders`, { headers }).then(res => res.json()),
                    fetch(`${process.env.REACT_APP_API_URL}/api/sociallink`, { headers }).then(res => res.json()),
                    fetch(`${process.env.REACT_APP_API_URL}/api/general`, { headers }).then(res => res.json()),
                    fetch(`${process.env.REACT_APP_API_URL}/api/promotion`, { headers }).then(res => res.json()),
                ]);

                setApiData(prev => ({
                    ...prev,
                    sliders: {
                        main: slidersData.filter(s => s.status === 'active' && s.slider_type === 'Main'),
                        favourite: slidersData.filter(s => s.status === 'active' && s.slider_type === 'Favourite'),
                        feature: slidersData.filter(s => s.status === 'active' && s.slider_type === 'Features'),
                        affiliate: slidersData.filter(s => s.status === 'active' && s.slider_type === 'Affiliate'),
                        commssion: slidersData.filter(s => s.status === 'active' && s.slider_type === 'Commssion'),
                        promotion: slidersData.filter(s => s.slider_type === 'Promotion'),
                        product: slidersData.filter(s => s.status === 'active' && s.slider_type === 'Product'),
                        guide: slidersData.filter(s => s.status === 'active' && s.slider_type === 'Guide'),
                        contact: slidersData.filter(s => s.status === 'active' && s.slider_type === 'Contact'),
                        about: slidersData.filter(s => s.status === 'active' && s.slider_type === 'About'),
                    },
                    socialLinks: socialData[0] || {},
                    general: generalData[0] || {},
                    promotions: {
                        activePromotion: promotionsData.filter(p => p.status === 'active'),
                        displayPromotion: promotionsData.filter(p => p.status === 'display'),
                        allPromotions: promotionsData,
                    },
                }));
            } catch (err) {
                console.error('Error fetching public data:', err);
                setError('Error fetching public API data');
            }
        };
        fetchPublicData();
    }, []);

    useEffect(() => {
        setGlobalData(apiData);
    }, [apiData, setGlobalData]);

    if (error) {
        return <div style={{ color: 'red', textAlign: 'center' }}>{error}</div>;
    }

    return null;
}

export default APIS;
